<template>
  <div class="repeat-group option-group d-flex">
    <template v-if="basicLang">
      <input type="text" class="form-control custom-input tag-name-input"
        :class="{ 'w-40': is_tag || is_ingredient, 'w-20': !is_tag || is_ingredient }" v-model="name">
    </template>
    <template v-else>
      <input type="text" class="form-control custom-input w-20 tag-name-input" v-model="translate.name"
        :placeholder="name" @update:modelValue="e => setTranslate('name', e)">
    </template>

    <div class="price-input-group d-flex justify-content-between w-30" v-if="!(is_tag || is_ingredient)">
      <input type="text" class="form-control custom-input price-input w-49" v-model.number="price">
      <input type="text" class="form-control custom-input price-input w-49" v-model="price_old">
    </div>
    <Popper arrow :content="$static('option.si', 'Зображення мітки')" hover placement="top" style="white-space: nowrap">
      <div class="img-upload btn-icon btn-icon-outline" @click="openFileManager">
        <span class="icon icon-picture"></span>
        <span class="loaded-picture bg" :style="{ 'background-image': $filters.backgroundImage(item.image) }"></span>
        <a href="#" class="btn-icon btn-remove btn-small" v-if="item.image" @click.prevent.stop="delImage">
          <span class="icon icon-trash-filled"></span>
        </a>
      </div>
    </Popper>

    <Popper arrow :content="$static('option.sc', 'Колір мітки')" hover placement="top" style="white-space: nowrap">
      <div class="colorpicker btn-icon btn-icon-outline" @click.prevent.stop="openColorPicker">
        <span class="icon icon-colorpicker"></span>
        <span class="pick-color" :style="{ 'background-color': color }"></span>
        <a href="#" class="btn-icon btn-remove btn-small" v-if="item.color" @click.prevent.stop="delColor">
          <span class="icon icon-trash-filled"></span>
        </a>
      </div>
    </Popper>


    <div class="button-group d-flex ">
      <div class="button-group-name">
        {{ $static('option.btngr', 'Дії:') }}
      </div>
      <div class="buttons d-flex">
        <template v-if="swappable">
          <Popper arrow :content="$static('option.up', 'Нагору')" hover placement="top" style="white-space: nowrap">
            <button class="remove btn-icon  btn-icon-outline" @click="up">
              <span class="icon icon-up"></span>
            </button>
          </Popper>
          <Popper arrow :content="$static('option.down', 'Вниз')" hover placement="top" style="white-space: nowrap">
            <button class="remove btn-icon btn-icon-outline" @click="down">
              <span class="icon icon-down"></span>
            </button>
          </Popper>
        </template>


        <Popper arrow :content="$static('option.del', 'Видалити')" hover placement="top" style="white-space: nowrap">
          <button class="remove btn-icon btn-icon-outline " @click="remove">
            <span class="icon icon-trash"></span>
          </button>
        </Popper>
        <div class="opt-check">
          <label v-if="is_tag">
            <input type="checkbox" v-model="isHidden" />
            {{ $static('option.hidd-tag', 'Відображати тільки на головній') }}
          </label>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OptionEditorFull',
  props: ['item', 'lang', 'swappable'],
  events: [
    'up',
    'down',
    'remove',
    'color'
  ],
  computed: {
    is_tag() {
      return this.item.option_id === 'tags'
    },
    is_ingredient() {
      return this.item.option_id === 'ingredient'
    },
    name: {
      get() {
        return this.item ? this.item.name : ''
      },
      set(value) {
        if (this.item) {
          this.item.name = value
        }
      }
    },
    price: {
      get() {
        return this.item ? this.item.price : ''
      },
      set(value) {
        if (this.item) {
          this.item.price = value
        }
      }
    },
    isHidden: {
      get() {
        return this.item && this.item.info ? this.item.info.hidden : false
      },
      set(value) {
        if (!this.item.info) {
          this.item.info = {}
        }
        this.item.info.hidden = value;
      }
    },
    price_old: {
      get() {
        return this.item ? this.item.price_old : ''
      },
      set(value) {
        if (this.item) {
          this.item.price_old = value
        }
      }
    },
    color: {
      get() {
        return this.item ? this.item.color : 'transparent'
      },
      set(value) {
        if (this.item) {
          this.item.color = value
        }
      }
    },
    basicLang() {
      return this.lang === ''
    },
    translate: {
      get() {
        return this.lang && this.item && this.item.translate && this.item.translate[this.lang] ? this.item.translate[this.lang] : {}
      },
      set(value) {
      }
    }
  },
  methods: {
    setTranslate(key, value) {
      if (!this.item.translate) {
        this.item.translate = {}
      }
      if (!this.item.translate[this.lang]) {
        this.item.translate[this.lang] = {}
      }
      this.item.translate[this.lang][key] = value
    },
    delColor() {
      this.item.color = null;
    },
    delImage() {
      this.item.image = null;
    },
    openFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.select);
    },
    select() {
      let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
      if (images) {
        this.item.image = images[0]
      } else {
        this.item.image = null
      }
    },
    up() {
      this.$emit('up')
    },
    openColorPicker(event) {
      this.$emit('color', event)
    },
    down() {
      this.$emit('down')
    },
    remove() {
      this.$emit('remove')
    }

  }
}
</script>

<!--<style scoped>-->
<!--.colorpicker .icon.icon-colorpicker {-->
<!--  -webkit-transform : translate(50%, -50%);-->
<!--}-->
<!--.img-upload .icon.icon-picture {-->
<!--  -webkit-transform : translate(50%, -50%);-->
<!--}-->
<!--</style>-->